import clsx from 'clsx';
import { ReactComponent as Star } from './trusted-shop-star.svg';
import styles from './TrustedShopsStarRating.module.scss';
import type { TrustedShopsStarRatingProps } from './types';

const stars = [1, 2, 3, 4, 5];

export const TrustedShopsStarRating = ({
  rating,
  color = 'default',
}: TrustedShopsStarRatingProps) => {
  const ratingText = `${rating.toString().replace('.', ',')} von 5 Sternen`;
  return (
    <div className={clsx(styles.starRow, styles[color])}>
      <span className="visually-hidden">{ratingText}</span>
      {stars.map((index) => {
        const fillPercentage =
          Math.min(Math.max(rating - (index - 1), 0), 1) * 100;

        return (
          <span
            key={index}
            className={clsx(styles.starContainer, styles[color])}
            aria-hidden="true"
          >
            <span className={clsx(styles.star, styles.empty)}>
              <Star />
            </span>
            <span
              className={styles.star}
              style={{
                clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`,
              }}
            >
              <Star />
            </span>
          </span>
        );
      })}
    </div>
  );
};
